import { combineReducers } from 'redux';

import locale from './locale';
import location from './location';
import home from './home';
import channel from './channel';
import banner from './banner';
import post from './post';
import socialMedia from './socialMedia';
import footer from './footer';
import auth from './auth';
import siteInfo from './siteInfo';
import header from './header';
import profile from './profile';
import alertBanner from './alertBanner';
import alertModal from './alertModal';
import error from './error';
import googleTagManager from './googleTagManager';
import campaign from './campaign';
import dashboard from './dashboard';
import accomplishment from './accomplishment';
import scoreRecord from './scoreRecord';
import tutorDashboard from './tutorDashboard';
import pagePost from './pagePost';
import subjectPage from './subjectPage';
import practice from './practice';
import socialWidget from './socialWidget';

const rootReducer = combineReducers({
  locale,
  location,
  home,
  channel,
  banner,
  post,
  socialMedia,
  footer,
  auth,
  siteInfo,
  header,
  profile,
  alertBanner,
  alertModal,
  error,
  googleTagManager,
  campaign,
  dashboard,
  accomplishment,
  scoreRecord,
  tutorDashboard,
  pagePost,
  subjectPage,
  practice,
  socialWidget,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./app/redux/reducers.js